<template>
    <div class="filter-inputs">
        <template v-if="tab === 'Users'">
            <div class="filter-inputs__all">
                <div class="filter-inputs__selects">
                    <ReportingSearchPhrase :placeholder="$t('ReportingFilters.filter_by_user_name')"/>
                    <ReportingSelectFilter v-bind="filterStaticData.memberStatus" />
                    <ReportingSelectFilter v-bind="filterStaticData.memberCompany" v-if="reportingConfiguration.hasCompanies" />
                    <ReportingSelectFilter v-bind="filterStaticData.memberDepartment" v-if="reportingConfiguration.hasDepartments" />
                    <ReportingSelectFilter v-bind="filterStaticData.memberTeam" v-if="reportingConfiguration.hasTeams" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseAuthorization" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseType" />
                </div>
                <div class="filter-inputs__dates">
                    <span v-html="$t('ReportingFilters.filter_by_date_range')"></span>
                    <ReportingDatePickerFilter
                        v-bind="filterStaticData.startDate"
                    /> -
                    <ReportingDatePickerFilter
                        v-bind="filterStaticData.endDate"
                    />
                    <slot/>
                </div>
            </div>
        </template>
        <template v-if="tab === 'Courses'">
            <div class="filter-inputs__all">
                <div class="filter-inputs__selects">
                    <ReportingSearchPhrase :placeholder="$t('ReportingFilters.filter_by_course_name')"/>
                    <ReportingSelectFilter v-bind="filterStaticData.courseInstructor" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseLevel" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseType" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseSubjectArea" />
                    <ReportingTreeSelectFilter v-bind="filterStaticData.courseCategory" />
                    <ReportingSelectFilter v-bind="filterStaticData.courseAuthorization" />
                </div>
                <div class="filter-inputs__dates">
                    <span v-html="$t('ReportingFilters.filter_by_date_range')"></span>
                    <ReportingDatePickerFilter v-bind="filterStaticData.startDate" />
                    -
                    <ReportingDatePickerFilter v-bind="filterStaticData.endDate" />
                    <HideUncompletedCourses />
                    <HideCompletedCourses />
                    <slot/>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ReportingSearchPhrase from 'components/user/organizationreport/filters/fields/ReportingSearchPhrase'
    import ReportingSelectFilter from 'components/user/organizationreport/filters/fields/ReportingSelectFilter'
    import ReportingDatePickerFilter from 'components/user/organizationreport/filters/fields/ReportingDatePickerFilter'
    import ReportingTreeSelectFilter from 'components/user/organizationreport/filters/fields/ReportingTreeSelectFilter'
    import HideUncompletedCourses from 'components/user/organizationreport/filters/toggles/HideUncompletedCourses'
    import HideCompletedCourses from 'components/user/organizationreport/filters/toggles/HideCompletedCourses'
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'
    import { mapGetters } from 'vuex'
    import moment from 'moment-timezone'

    export default {
        name: 'FilterInputs',
        components: { ReportingSearchPhrase,
                      ReportingSelectFilter,
                      ReportingDatePickerFilter,
                      HideUncompletedCourses,
                      HideCompletedCourses,
                      ReportingTreeSelectFilter
        },
        mixins: [ filteringHelper ],
        inject: ['tab'],
        computed: {
            ...mapGetters({
                reportingConfiguration: 'ReportsUsers/getReportingConfiguration'
            }),
            filterStaticData () {
                return {
                    ...this.getFilterStaticData,
                    startDate: {
                        ...this.getFilterStaticData.startDate,
                        initialValue: Object.keys(this.reportingConfiguration).length !== 0 ? this.reportingConfiguration.minDate : moment().tz(this.getTimeZone()).subtract(1, 'days').format()
                    },
                    endDate: {
                        ...this.getFilterStaticData.endDate,
                        initialValue: moment().tz(this.getTimeZone()).subtract(1, 'days').format()
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter-inputs {
        &__selects {
            display: flex;
            flex: 1;
            flex-wrap: wrap;
        }

        &__all {
            display: flex;
            flex-direction: column;
            flex: 1;
        }

        &__dates {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px 0;
        }
    }
</style>
